import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Label } from 'recharts';
import numeral from 'numeral';

export const PortionChart = React.memo(({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart width={400} height={200}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={75}
          outerRadius={100}
          labelLine={false}
        >
          {data.map(s => (
            <Cell key={s.name} fill={s.color} />
          ))}
          <Label
            value={`${numeral(data[0].value).format('0.0')}%`}
            position="center"
            style={{ fontSize: '28px', fontWeight: 'bold', fill: '#778CA6' }}
          />
          <Label
            value="of total budget"
            position="center"
            style={{ fontSize: '14px', fill: '#666' }}
            dy={30}
          />
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
});
